import React from "react";
import AdminLayout from "../../components/layouts/AdminLayout";
import { UserCheck, Link2, Shield } from "lucide-react";

const AdminFarmers = () => {
  const farmers = [
    { name: "Amina Kip", company: "Maziwa Dairy", status: "Active" },
    { name: "John Mwangi", company: "FreshFarm Co", status: "Pending" },
    { name: "Lydia Muriithi", company: "Green Fields", status: "Suspended" },
  ];

  return (
    <AdminLayout>
      <div className="space-y-6">
        <header className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center border border-emerald-100">
            <UserCheck className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-slate-900">Farmers</h1>
            <p className="text-sm text-slate-600">
              Onboard farmers, link them to companies, and handle compliance.
            </p>
          </div>
        </header>

        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-hidden">
          <table className="min-w-full divide-y divide-slate-100">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600">Farmer</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600">Company</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600">Status</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {farmers.map((farmer) => (
                <tr key={farmer.name}>
                  <td className="px-4 py-3 text-sm text-slate-800">{farmer.name}</td>
                  <td className="px-4 py-3 text-sm text-slate-700">{farmer.company}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                        farmer.status === "Active"
                          ? "bg-emerald-50 text-emerald-700"
                          : farmer.status === "Pending"
                          ? "bg-amber-50 text-amber-700"
                          : "bg-rose-50 text-rose-700"
                      }`}
                    >
                      {farmer.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-slate-700 flex items-center gap-2">
                    <button className="px-2 py-1 text-xs font-semibold text-blue-700 hover:underline">
                      View
                    </button>
                    <button className="px-2 py-1 text-xs font-semibold text-emerald-700 hover:underline">
                      Approve
                    </button>
                    <button className="px-2 py-1 text-xs font-semibold text-rose-700 hover:underline">
                      Suspend
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <div className="bg-white border border-slate-100 rounded-xl p-4 shadow-sm">
            <div className="flex items-center gap-3 mb-2">
              <Link2 className="h-5 w-5 text-blue-600" />
              <p className="text-sm font-semibold text-slate-900">Link to companies</p>
            </div>
            <p className="text-sm text-slate-600">
              Connect farmers to a company so they can access payments, journals, and marketplace tools.
            </p>
          </div>

          <div className="bg-white border border-slate-100 rounded-xl p-4 shadow-sm">
            <div className="flex items-center gap-3 mb-2">
              <Shield className="h-5 w-5 text-emerald-600" />
              <p className="text-sm font-semibold text-slate-900">Compliance</p>
            </div>
            <p className="text-sm text-slate-600">
              Validate IDs, farm details, and production records. Flag issues for company admins to resolve.
            </p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminFarmers;
